export default __webpack_public_path__ + "static/media/stranger.8544a6eb.png";